// extracted by mini-css-extract-plugin
export default {"tooltipContent":"styles__tooltipContent___3p0yf"};